export const LEAD_PERMISSIONS = {
	view: "SCREEN_LEADS",
	edit: "LEADS_EDIT",
	export: "LEADS_DATA_EXPORT",
} as const

export function getLeadAccess(acl: readonly string[]) {
	return {
		canView: acl.includes(LEAD_PERMISSIONS.view),
		canEdit: acl.includes(LEAD_PERMISSIONS.edit),
		canExport: acl.includes(LEAD_PERMISSIONS.export),
	}
}

export type LeadBusinessAccessSource = {
	internalID: string
	showLeadsScreen: boolean
	acl: readonly string[]
}

export function getLeadBusinessesAccess(
	businesses: readonly LeadBusinessAccessSource[],
) {
	const visibleBusinesses = businesses.filter((business) => {
		if (!business.showLeadsScreen) return false
		return getLeadAccess(business.acl).canView
	})
	const accessByBusinessId = new Map(
		visibleBusinesses.map((business) => [
			business.internalID,
			getLeadAccess(business.acl),
		]),
	)

	return {
		visibleBusinesses,
		canView: visibleBusinesses.length > 0,
		canExport: visibleBusinesses.some(
			(business) => getLeadAccess(business.acl).canExport,
		),
		canEditBusiness: (businessId: string) =>
			accessByBusinessId.get(businessId)?.canEdit ?? false,
	}
}
